export class ErrorBase extends Error {
  override message: string

  override cause?: Error

  code?: string

  constructor({ message, cause, code }: { message: string; cause?: Error; code?: string }) {
    super()

    this.message = message
    this.cause = cause
    this.code = code
  }
}
